export default __webpack_public_path__ + "static/media/B.0cacae35.png";